import { useCallback } from 'react'

export const useShareProductSelection = ({ newOrderProducts, quantities }) => {
  const hasSelectedProductsToPurchase = useCallback(() => {
    if (!newOrderProducts || !newOrderProducts.length) return false
    return newOrderProducts.some((product) => {
      const splitQty = quantities[`${product.id}-${product.index}-split`] ?? 0
      const subItemQty = (product.subItems ?? []).reduce(
        (acc, sub) => acc + (Number(sub.quantity ?? sub.qty) || 0),
        0
      );
      return (
        product.quantity > 0 ||
        subItemQty > 0 ||
        (product.splitCasePurchase && product.splitCasePurchase.enabled && splitQty > 0)
      )
    })
  }, [newOrderProducts, quantities])

  return {
    hasSelectedProductsToPurchase,
  }
}
